export default "__VITE_ASSET__1f899318__"